import LoginPage from "../pages/auth/LoginPage";

export const authRoutes = [
  //   {
  //     name: "Register",
  //     path: "register",
  //     element: <RegisterPage />,
  //   },
  {
    name: "Login",
    path: "login",
    element: <LoginPage />,
  },
];
